/** Default calendar year — single source of truth for the app */
export const CALENDAR_YEAR = 2026;
